import React, { useEffect, useState } from "react"
import { Link } from "gatsby"

const LAYOUT_DESKTOP_ONLY = 1

/**
 * This component will render the sub navigation.
 * It does not support any extra styling or paddings.
 * When the "links" property is not set or an empty list
 * nothing will be rendered.
 */
const MSubNavigation = (props) => {
  const links = props.data.links
  const [activeLink, setActiveLink] = useState(null)

  const getLinkWithoutParamsAndAnchor = (link) =>
    link ? link.replace(/^([^#?]+)([#?].*)?$/, "$1") : null

  useEffect(() => {
    const currentNavItem = links.find((item) => {
      const linkToPage = getLinkWithoutParamsAndAnchor(item.link)
      return (
        document.location.pathname === linkToPage ||
        getLinkWithoutParamsAndAnchor(document.location.href) === linkToPage
      )
    })
    setActiveLink(currentNavItem ? currentNavItem.link : null)
  }, [links])

  const SubNavLink = ({ link, className, children }) => {
    if (link.indexOf(":") < 0) {
      // relative link
      return (
        <Link to={link} className={className}>
          {children}
        </Link>
      )
    }
    return (
      <a href={link} className={className}>
        {children}
      </a>
    )
  }

  if (!links || links.length === 0) {
    return null
  }

  return (
    <>
      <div
        className={`m-Subnav${
          props.data.layout === LAYOUT_DESKTOP_ONLY
            ? " m-Subnav--desktop-only"
            : ""
        }`}
      >
        <ul className="m-Subnav-list">
          {links.map((item) => (
            <li
              key={item.link}
              className={`m-Subnav-item${
                item.link === activeLink ? " is-active" : ""
              }`}
            >
              <SubNavLink link={item.link} className="m-Subnav-link">
                {item.link_text}
              </SubNavLink>
            </li>
          ))}
        </ul>
      </div>
      <div className="m-Subnav-helper"></div>
    </>
  )
}

export default MSubNavigation
